export function isDebugMode(): boolean {
  return new URLSearchParams(window.location.search).get('debug') === '1';
}

export function logBroadcastTiming(label: string, clickTime: number, responseTime: number): void {
  if (!isDebugMode()) return;

  const clickToResponseMs = responseTime - clickTime;

  console.log(JSON.stringify({
    action: 'perf-debug-broadcast',
    label,
    clickToResponseMs,
    clickTimeISO: new Date(clickTime).toISOString(),
    responseTimeISO: new Date(responseTime).toISOString()
  }));
}
